import * as Sentry from '@sentry/browser';

document.addEventListener('DOMContentLoaded', () => {
  if (process.env.SENTRY_RELEASE && document.body.dataset.sentryFrontendFeature === 'true') {
    Sentry.init({
      dsn: 'https://b956da59124f49d78d780821bb3d9cc6@o225095.ingest.sentry.io/1376323',
      release: process.env.SENTRY_RELEASE,
      whitelistUrls: [
        /https?:\/\/static.vecteezy\.com/,
      ],
    });
  }
});
